<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Добавить язык</h4>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form autcomplete="off" @submit.prevent="languageStore()">
                  <div class="form-group">
                    <label>Язык</label>
                    <input type="text" placeholder="ru" class="form-control" v-model="language.lang" autofocus />
                  </div>
                  <div class="form-group">
                    <label>Первый заглавную</label>
                    <input type="text" placeholder="Ru" class="form-control" v-model="language.firstCapital" />
                  </div>
                  <div class="form-group">
                    <label>Все заглавную</label>
                    <input type="text" placeholder="RU" class="form-control" v-model="language.capital" />
                  </div>
                  <div class="form-group">
                    <label>Подчеркивание</label>
                    <input type="text" placeholder="ru_RU" class="form-control" v-model="language.plural" />
                  </div>
                  <button type="submit" class="btn btn-primary">Добавить</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { POST } from "../../shared/api";
export default {
  data() {
    return {
      language: {},
    };
  },
  methods: {
    languageStore() {
      POST(this.language, "/language", this).then(response => {
        this.$router.push({ name: "language" });
      });
    }
  },
  mounted() {
    let input = document.querySelector("[autofocus]");
    if (input) {
      input.focus();
    }
  }
};
</script>
